import { render, staticRenderFns } from "./index.vue?vue&type=template&id=011beb19"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011beb19')) {
      api.createRecord('011beb19', component.options)
    } else {
      api.reload('011beb19', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=011beb19", function () {
      api.rerender('011beb19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/map/index.vue"
export default component.exports